export default "__VITE_ASSET__f_SM2xMf__"